export default __webpack_public_path__ + "static/media/casaduana_FernandoMejia.03381b0c.png";